import { render, staticRenderFns } from "./FamousCommentReport.vue?vue&type=template&id=5768b25a&"
import script from "./FamousCommentReport.vue?vue&type=script&lang=js&"
export * from "./FamousCommentReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports